import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../App.css';
import { Link } from 'react-router-dom';
import Logo from "../Rijschool.png";

const API_URL = (process.env.REACT_APP_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:3001' : '')) + '/api';

function FeedbackOverview() {
  const [rijscholen, setRijscholen] = useState([]);
  const [selectedRijschool, setSelectedRijschool] = useState('');

  useEffect(() => {
    fetchRijscholen();
  }, []);

  const fetchRijscholen = async () => {
    try {
      const response = await axios.get(`${API_URL}/rijscholen`);
      setRijscholen(response.data);
    } catch (error) {
      console.error('Fout bij ophalen van rijscholen:', error);
    }
  };

  const fetchQuestions = async (rijschool) => {
    try {
      await axios.get(`${API_URL}/overview?rijschool=${rijschool}`);
    } catch (error) {
      console.error('Fout bij ophalen van vragen:', error);
    }
  };

  const handleRijschoolChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedRijschool(selectedValue);
    fetchQuestions(selectedValue);
  };

  return (
    <div className="main-content-wrapper fade-in-up">
      <div className="top-left-fixed">
        <Link to="/" className="action-button-blue">Home</Link>
      </div>
      
      <h1 className="aharoni-style" style={{ fontSize: '2.5em', marginBottom: '40px' }}>Feedback Overzicht</h1>

      <div className="admin-card" style={{ width: '100%', maxWidth: '500px', padding: '30px' }}>
        <div className="form-container" style={{ maxWidth: 'none', width: '100%' }}>
          <label className="form-label" htmlFor="rijschoolSelect">Selecteer een rijschool:</label>
          <select 
            id="rijschoolSelect" 
            value={selectedRijschool} 
            onChange={handleRijschoolChange}
            className="form-select"
          >
            <option value=""> Kies een rijschool</option>
            {rijscholen.map((rijschool, index) => (
              <option key={index} value={rijschool.rijschool_naam || rijschool.namen}>
                {rijschool.rijschool_naam || rijschool.namen}
              </option>
            ))}
          </select>
          
          <div style={{ marginTop: '20px' }}>
             <Link to="/form" state={{ selectedRijschool }} className="btn" style={{ width: '100%', minWidth: 'auto' }}>
                Vragenlijst Bekijken
             </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeedbackOverview;
